import React, { useState, useEffect, useMemo } from 'react';
import { initializeApp } from 'firebase/app';
import { 
    getAuth, 
    onAuthStateChanged, 
    createUserWithEmailAndPassword, 
    signInWithEmailAndPassword, 
    signOut 
} from 'firebase/auth';
import { getFirestore, collection, addDoc, onSnapshot, query, doc, deleteDoc } from 'firebase/firestore';

// --- Configuración de Firebase ---
// IMPORTANTE: Reemplaza este objeto con la configuración de tu propio proyecto de Firebase.
// La encuentras en: Configuración del Proyecto > General > Tus apps > Configuración del SDK.
const firebaseConfig = {
  apiKey: "AIza...",
  authDomain: "tu-proyecto.firebaseapp.com",
  projectId: "tu-proyecto",
  storageBucket: "tu-proyecto.appspot.com",
  messagingSenderId: "...",
  appId: "1:..."
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

// --- Componente de Login ---
const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoginView, setIsLoginView] = useState(true);

    const handleAuthAction = async (e) => {
        e.preventDefault();
        setError('');
        try {
            if (isLoginView) {
                await signInWithEmailAndPassword(auth, email, password);
            } else {
                await createUserWithEmailAndPassword(auth, email, password);
            }
        } catch (err) {
            setError('Ocurrió un error. Verifica tus credenciales.');
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md">
                <div className="text-center">
                    <h1 className="text-3xl font-bold text-gray-900">Gestión Financiera</h1>
                    <p className="text-gray-500">{isLoginView ? 'Inicia sesión para continuar' : 'Crea una cuenta para empezar'}</p>
                </div>
                {error && <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded text-center" role="alert">{error}</div>}
                <form onSubmit={handleAuthAction} className="space-y-6">
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Correo electrónico" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                    <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Contraseña" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500" />
                    <button type="submit" className="w-full py-2 px-4 font-semibold text-white bg-indigo-600 rounded-md hover:bg-indigo-700 transition-colors">
                        {isLoginView ? 'Iniciar Sesión' : 'Registrar Cuenta'}
                    </button>
                </form>
                <p className="text-sm text-center text-gray-600">
                    {isLoginView ? '¿No tienes cuenta?' : '¿Ya tienes una cuenta?'}
                    <button onClick={() => { setIsLoginView(!isLoginView); setError(''); }} className="ml-1 font-medium text-indigo-600 hover:underline">
                        {isLoginView ? 'Regístrate' : 'Inicia Sesión'}
                    </button>
                </p>
            </div>
        </div>
    );
};


// --- Componente del Panel Principal (Dashboard) ---
const Dashboard = ({ user }) => {
    // State and functions for the dashboard go here...
    const handleSignOut = async () => {
        try { await signOut(auth); } catch (error) { console.error("Error signing out", error); }
    };

    return (
        <div className="bg-gray-100 min-h-screen font-sans text-gray-800">
           <div className="container mx-auto p-4 md:p-8">
                <header className="flex flex-col md:flex-row justify-between items-center mb-8 pb-4 border-b border-gray-300">
                    <h1 className="text-3xl font-bold text-gray-900">Panel de Control</h1>
                     <div className="flex items-center gap-4">
                        <p className="text-sm text-gray-500 hidden md:block">Usuario: {user.email}</p>
                        <button onClick={handleSignOut} className="bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded-md text-sm transition-colors">Salir</button>
                    </div>
                </header>
                 {/* Dashboard content will go here */}
            </div>
        </div>
    );
};

// --- Componente Raíz ---
export default function App() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);

    if (loading) {
        return <div className="flex items-center justify-center min-h-screen">Cargando...</div>;
    }

    return user ? <Dashboard user={user} /> : <LoginPage />;
}

